import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, debounceTime, exhaustMap, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { DeletedOrdersActions } from '../actions/index';
import { OrderService } from '@app/services/order/order.service';

@Injectable()
export class DeletedOrdersEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private orderService: OrderService,
  ) {}

  loadDeletedOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeletedOrdersActions.loadDeletedOrders),
      exhaustMap(({ queryParameters }, loaded) => {
        return this.orderService.getDeletedOrders(queryParameters).pipe(
          map(({ orders, count }) => {
            return DeletedOrdersActions.loadDeletedOrdersSuccess({
              orders,
              count,
            });
          }),
          debounceTime(500),
          catchError(() => {
            return of(DeletedOrdersActions.loadDeletedOrdersFailure());
          }),
        );
      }),
    ),
  );

  restoreOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeletedOrdersActions.restoreOrders),
      mergeMap(({ ordersId }, loaded) => {
        return this.orderService.restoreOrders(ordersId).pipe(
          map(() => {
            return DeletedOrdersActions.restoreOrdersSuccess();
          }),
          debounceTime(500),
          catchError(() => {
            return of(DeletedOrdersActions.restoreOrdersFailure());
          }),
        );
      }),
    ),
  );
}
